module.exports = __webpack_public_path__ + "media/images/lesson_9/nini_caderno-134dc58cc32883b11dfa116870ad4a9c.png";